import {
  Button,
  FormControl,
  FormLabel,
  Select,
  SimpleGrid,
  Center,
  Stack,
  Tag,
  TagCloseButton,
  TagLabel,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useController } from "react-hook-form";
import useSWR from "swr";

function GoalTag({ label, onClick }) {
  return (
    <Tag size="lg" borderRadius="full" variant="outline" colorScheme="pink">
      <TagLabel>{label}</TagLabel>
      <TagCloseButton onClick={onClick} />
    </Tag>
  );
}

export function GoalMultiSelect({ name, control, projectId, gridColumns }) {
  // UI state
  const [goalId, setGoalId] = useState("");
  // goalId = "id1"
  // selectedGoalIds & value = ["id1", "id2", ...]
  const {
    field: { value, onChange },
    fieldState: { invalid, error },
  } = useController({ name, control });
  const [selectedGoalIds, setSelectedGoalIds] = useState(value);

  const { data: goals, error: swrError } = useSWR(
    `/projects/${projectId}/goals`
  );

  function handleChangeGoal(goalId) {
    setGoalId(goalId);
  }

  function addValue() {
    if (!selectedGoalIds.includes(goalId) && goalId !== "") {
      setSelectedGoalIds((prevState) => [...prevState, goalId]); // UI update
      onChange([...value, goalId]); // value update
    }
  }

  function removeValue(goalId) {
    setSelectedGoalIds((prevState) => prevState.filter((g) => g !== goalId)); // UI update
    onChange(value.filter((g) => g !== goalId)); // value update
  }

  return (
    <Stack direction={"column"} spacing="12px">
      <FormControl isInvalid={invalid}>
        <FormLabel>Proje Amacı</FormLabel>
        {!goals ? (
          // empty select as placeholder
          <Select variant={"filled"} placeholder="Lütfen seçiniz" />
        ) : (
          <Select
            placeholder="Lütfen seçiniz"
            variant={"filled"}
            name="goalId"
            value={goalId}
            onChange={(e) => handleChangeGoal(e.target.value)}
          >
            {goals.map(({ _id, name }) => (
              <option key={_id} value={_id}>
                {name}
              </option>
            ))}
          </Select>
        )}
      </FormControl>

      <Stack direction="row" spacing="12px">
        <Button size={"sm"} onClick={addValue} colorScheme="blue">
          <AddIcon />
        </Button>
        {selectedGoalIds?.length > 0 && (
          <SimpleGrid
            columns={gridColumns}
            spacing={2}
            border={"2px"}
            borderColor="gray.200"
            borderRadius={"lg"}
            p={2}
          >
            {selectedGoalIds.map((id) => (
              <GoalTag
                key={id}
                label={goals?.filter((g) => g._id === id)[0]?.name}
                onClick={() => removeValue(id)}
              />
            ))}
          </SimpleGrid>
        )}
        <Center color={"red.500"}>{error?.message}</Center>
      </Stack>
    </Stack>
  );
}
